



























































































































































import Vue from 'vue';
import QRCode from 'qrcode';
import moment from 'moment';
import ReservationCardDetails from '@/components/Reservations/ReservationCardDetails.vue';
import { getLowestUtilizedEntrance, logError, apiDeleteRequest } from '../helpers';
import {
  ReservationEntity,
  GetReservationOptions,
  APIDeleteRequest,
  GetExternalUserReservationsOptions,
  LocationEntity,
  ScanEntity,
  CurrentCheckIn,
} from '../../../types';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

export default Vue.extend({
  name: 'reservation-details',
  components: {
    ReservationCardDetails,
  },
  data() {
    return {
      qrCodeDataURL: null,
    };
  },
  props: {
    reservationQRCode: {
      type: String,
      required: true,
    },
  },
  methods: {
    manageReservations() {
      this.$router.push({
        name: 'manage-reservations',
        params: {
          pathExternalUserId: (this as any).reservation.externalUserId,
        },
        query: {
          customerId: (this as any).reservation.customerId,
        },
      });
    },
    checkIn() {
      this.$router.push({
        name: 'location-check-in',
        params: {
          reservationQRCode: this.reservationQRCode,
        },
      });
    },
    modifyReservation() {
      this.$router.push({
        name: 'modify-reservation',
        params: {
          reservationQRCode: (this as any).reservation.qrCode,
          reservationLocationId: (this as any).reservation.locationId.toString(),
        },
        query: {
          apiKey: (this as any).reservation.apiKeyUsed,
          customerId: (this as any).reservation.customerId,
          locationId: (this as any).reservation.locationId,
          occupantTypeId: (this as any).reservation.occupantTypeId,
          lang: this.$root.$i18n.locale,
          webview: (this as any).webview,
          primaryColor: (this as any).primaryColor.replace('#', ''),
          primaryFontColor: (this as any).primaryFontColor.replace('#', ''),
          primaryButtonFontColor: (this as any).primaryButtonFontColor.replace('#', ''),
          secondColor: (this as any).secondColor.replace('#', ''),
          secondFontColor: (this as any).secondFontColor.replace('#', ''),
          secondButtonFontColor: (this as any).secondButtonFontColor.replace('#', ''),
          thirdColor: (this as any).thirdColor.replace('#', ''),
          thirdFontColor: (this as any).thirdFontColor.replace('#', ''),
          thirdButtonFontColor: (this as any).thirdButtonFontColor.replace('#', ''),
          fourthColor: (this as any).fourthColor.replace('#', ''),
          fourthFontColor: (this as any).fourthFontColor.replace('#', ''),
          fourthButtonFontColor: (this as any).fourthButtonFontColor.replace('#', ''),
          headerBackgroundColor: (this as any).headerBackgroundColor.replace('#', ''),
          languagePickerColor: (this as any).languagePickerColor.replace('#', ''),
          ...((this as any).reservation.externalUserId && {
            externalUserId: (this as any).reservation.externalUserId,
          }),
          ...((this as any).widgetLayout && {
            widgetLayout: (this as any).widgetLayout,
          }),
          ...((this as any).cssURL && { cssURL: (this as any).cssURL }),
          ...((this as any).visitTypeId && { visitTypeId: (this as any).visitTypeId }),
          ...((this as any).fcmToken && { fcmToken: (this as any).fcmToken }),
          ...((this as any).queryParametersName && { name: (this as any).queryParametersName }),
          ...((this as any).queryParametersEmail && { email: (this as any).queryParametersEmail }),
        },
      });
    },
    handleCancelReservation(): void {
      (this as any).$Simplert.open({
        title: this.$t('text.are_you_sure'),
        message: this.$t('text.are_you_sure_cancel'),
        type: 'warning',
        customCloseBtnText: this.$t('text.close'),
        customCloseBtnClass: 'btn fourth-button',
        useConfirmBtn: true,
        onConfirm: this.cancelReservation,
        customConfirmBtnText: this.$t('text.cancel_reservation'),
        customConfirmBtnClass: 'btn primary-button',
      });
    },
    async cancelReservation(): Promise<void> {
      (this as any).showLoader();

      const customerId = (this as any).reservation.customerId;
      const locationId = (this as any).reservation.locationId;
      const reservationId = (this as any).reservation.id;
      const externalUserId = (this as any).reservation.externalUserId || (this as any).reservation.qrCode;

      const deleteOptions: APIDeleteRequest = {
        apiKey: externalUserId,
        apiURL: `${apiBaseURL}customer/${customerId}/location/${locationId}/reservation/${reservationId}`,
      };

      const deleteRequest = await apiDeleteRequest(deleteOptions);

      (this as any).hideLoader();

      if (deleteRequest) {
        if ((this as any).reservation.externalUserId) {
          this.manageReservations();
        } else {
          this.$router.push({
            name: 'reserve',
            query: {
              apiKey: (this as any).reservation.apiKeyUsed,
              customerId: (this as any).reservation.customerId,
              locationId: (this as any).reservation.locationId,
              occupantTypeId: (this as any).reservation.occupantTypeId,
              lang: this.$root.$i18n.locale,
              webview: (this as any).webview,
              primaryColor: (this as any).primaryColor.replace('#', ''),
              primaryFontColor: (this as any).primaryFontColor.replace('#', ''),
              primaryButtonFontColor: (this as any).primaryButtonFontColor.replace('#', ''),
              secondColor: (this as any).secondColor.replace('#', ''),
              secondFontColor: (this as any).secondFontColor.replace('#', ''),
              secondButtonFontColor: (this as any).secondButtonFontColor.replace('#', ''),
              thirdColor: (this as any).thirdColor.replace('#', ''),
              thirdFontColor: (this as any).thirdFontColor.replace('#', ''),
              thirdButtonFontColor: (this as any).thirdButtonFontColor.replace('#', ''),
              fourthColor: (this as any).fourthColor.replace('#', ''),
              fourthFontColor: (this as any).fourthFontColor.replace('#', ''),
              fourthButtonFontColor: (this as any).fourthButtonFontColor.replace('#', ''),
              headerBackgroundColor: (this as any).headerBackgroundColor.replace('#', ''),
              languagePickerColor: (this as any).languagePickerColor.replace('#', ''),
              ...((this as any).reservation.externalUserId && {
                externalUserId: (this as any).reservation.externalUserId,
              }),
              ...((this as any).widgetLayout && {
                widgetLayout: (this as any).widgetLayout,
              }),
              ...((this as any).cssURL && { cssURL: (this as any).cssURL }),
              ...((this as any).visitTypeId && { visitTypeId: (this as any).visitTypeId }),
              ...((this as any).fcmToken && { fcmToken: (this as any).fcmToken }),
              ...((this as any).queryParametersName && { name: (this as any).queryParametersName }),
              ...((this as any).queryParametersEmail && { email: (this as any).queryParametersEmail }),
            },
          });
        }
      } else {
        (this as any).$Simplert.open({
          title: this.$t('text.reservation_error'),
          message: this.$t('text.reservation_cancel_error_message'),
          type: 'warning',
          customCloseBtnText: this.$t('text.close'),
          customCloseBtnClass: 'btn fourth-button',
          useConfirmBtn: true,
          onConfirm: this.cancelReservation,
          customConfirmBtnText: this.$t('text.try_again'),
          customConfirmBtnClass: 'btn primary-button',
        });
      }
    },
  },
  computed: {
    isFuture(): boolean {
      return !(this as any).reservation.manualGroup
        ? moment().isBefore(moment(`${(this as any).reservation.startDate}T${(this as any).reservation.timeslot.startTime}`))
        : false;
    },
    doesNotHaveScans(): boolean {
      return (this as any).reservation.scans.length === 0;
    },
  },
  async created() {
    (this as any).startLoading();

    (this as any).updateQueryParameters();

    this.$store.commit('appData/REMOVE_EXISTING_DATA');

    const options: GetReservationOptions = {
      qrCode: this.reservationQRCode,
      customerId: (this as any).customerId,
    };

    await this.$store.dispatch('appData/GET_RESERVATION', options);

    (this as any).stopLoading();
  },
  watch: {
    async reservation(newVal) {
      if (newVal) {
        if (newVal.qrCode) {
          this.qrCodeDataURL = await QRCode.toDataURL(this.reservationQRCode);
        }

        const location: LocationEntity = newVal.location;
        const locations: LocationEntity[] = newVal.locations;

        if (location || locations) {
          const translations =
            location && location.translations
              ? location.translations
              : locations && locations.find((location) => location.translations)
              ? locations.find((location) => location.translations)!.translations
              : null;

          const visualSettings =
            location && location.visualSettings
              ? location.visualSettings
              : locations && locations.find((location) => location.visualSettings)
              ? locations.find((location) => location.visualSettings)!.visualSettings
              : null;

          (this as any).setTranslations(translations, newVal.lang);

          (this as any).setVisualSettings(visualSettings);
        }
      }
    },
  },
});
